export default __webpack_public_path__ + "static/media/OwlPage1.35e1172b.txt";